var __jsx = React.createElement;
import { cn } from '@lib/cn';
import { useNotifications } from '@lib/context/shared/notifications-context';
import React, { useEffect, useRef } from 'react';
import { NotificationType } from 'types/shared/notification-types';
import { IconButton } from '../buttons';
import APP_CONFIGURATION from '@lib/app.config';
import Icons from '../../../icons';
import { useMediaQuery } from 'react-responsive';
import { BREAKPOINTS } from '@lib/constants';
const bigNotificationTopHidden = "-100px";
const MuscleNotification = () => {
  var _APP_CONFIGURATION$co, _APP_CONFIGURATION$co2;
  const styleConfig = APP_CONFIGURATION.config.notificationStyleConfig || {
    success: "bg-success-main text-white",
    error: "bg-error-main text-white",
    warning: "bg-warning-main text-white",
    info: "bg-tertiary_a-main text-white"
  };
  const {
    show,
    setShow,
    message,
    type
  } = useNotifications();
  const notificationRef = useRef(null);
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat((_APP_CONFIGURATION$co = (_APP_CONFIGURATION$co2 = APP_CONFIGURATION.config.screensConfig) === null || _APP_CONFIGURATION$co2 === void 0 ? void 0 : _APP_CONFIGURATION$co2.sm) !== null && _APP_CONFIGURATION$co !== void 0 ? _APP_CONFIGURATION$co : "".concat(BREAKPOINTS.sm, "px"), ")")
  });
  useEffect(() => {
    if (notificationRef.current) {
      if (show) {
        var _APP_CONFIGURATION$co3, _APP_CONFIGURATION$co4, _APP_CONFIGURATION$co5, _APP_CONFIGURATION$co6;
        notificationRef.current.style.top = isMobile ? (_APP_CONFIGURATION$co3 = (_APP_CONFIGURATION$co4 = APP_CONFIGURATION.config.notificationAbsolutePosition) === null || _APP_CONFIGURATION$co4 === void 0 ? void 0 : _APP_CONFIGURATION$co4.mobileSize) !== null && _APP_CONFIGURATION$co3 !== void 0 ? _APP_CONFIGURATION$co3 : '56px' : (_APP_CONFIGURATION$co5 = (_APP_CONFIGURATION$co6 = APP_CONFIGURATION.config.notificationAbsolutePosition) === null || _APP_CONFIGURATION$co6 === void 0 ? void 0 : _APP_CONFIGURATION$co6.desktopSize) !== null && _APP_CONFIGURATION$co5 !== void 0 ? _APP_CONFIGURATION$co5 : '56px';
      } else {
        notificationRef.current.style.top = bigNotificationTopHidden;
      }
    }
  }, [show, isMobile]);
  return __jsx("div", {
    ref: notificationRef,
    style: {
      position: 'fixed',
      top: bigNotificationTopHidden,
      transition: 'top 0.3s'
    },
    className: cn('z-[10000] w-full flex flex-row items-center justify-between tx-pdm-regular md:tx-pms-regular default-padding text-white max-h-[100px]', {
      [styleConfig.success]: type === NotificationType.SUCCESS,
      [styleConfig.error]: type === NotificationType.ERROR,
      [styleConfig.warning]: type === NotificationType.WARNING,
      [styleConfig.info]: type === NotificationType.INFO
    })
  }, message, __jsx(IconButton, {
    icon: __jsx(Icons.xIcon, null),
    onClickButton: () => setShow(false)
  }));
};
export default MuscleNotification;